<template>
<div>
    <header v-if="$route.params.id != 'me'">
        <a href="#" @click.prevent="goBack" class="back"></a>
        <h1>Profil</h1>
    </header>
    <section>
        <div class="item">
            <dp :who="who" />
            <header v-if="who.id == user.id">
                <h3>
                    {{ who | name }}
                    {{ who.firstname.toLowerCase() != who.username.toLowerCase() ? `aka ${who.username}` : '' }}
                </h3>
                <div>
                    <router-link to="/profile/edit" class="btn-secondary">Bearbeiten</router-link>
                </div>
            </header>
            <h3 v-else>{{ who | name }}</h3>
            <small>{{ byline }}</small>
        </div>
    </section>

    <section v-if="who.id != user.id">
        <friendship-button :who="who" />
    </section>

    <section>
        <header>
            <h2>Statistik</h2>
            <div>
                <router-link :to="`/profile/${$route.params.id}/stats`" class="btn-primary">Mehr</router-link>
            </div>
        </header>
        <elo-chart :matches="matches" :userId="who.id" />
    </section>

    <section>
        <header>
            <h2>Freunde</h2>
            <div>
                <router-link :to="`/profile/${$route.params.id}/friends`" class="btn-primary">Mehr</router-link>
            </div>
        </header>
        <div class="dp-list">
            <div v-for="friend in who.friends" class="dp-item">
                <dp :who="friend" />
            </div>
        </div>
    </section>

    <section>
        <div class="info">
            <label>ELO</label>
            <p>{{ who.elo }}</p>
        </div>

        <div class="info" v-if="who.motto">
            <label>Spielmotto</label>
            <p>{{ who.motto }}</p>
        </div>

        <div class="info" v-if="who.racket">
            <label>Racket</label>
            <p>{{ who.racket }}</p>
        </div>

        <div class="info" v-if="who.school">
            <label>Schulhaus</label>
            <p>{{ who.school.name }}</p>
        </div>
    </section>

    <section>
        <a href="#" @click.prevent="logout()" class="btn btn-secondary">
            Ausloggen
        </a>
    </section>
</div>
</template>

<script>
import base from 'base.vue'
import eloChart from 'components/elo-chart.vue'
import friendshipButton from 'components/friendship-button.vue'
import dp from 'components/dp.vue'
import _ from 'underscore'

export default {
    mixins: [ base ],
    components: { eloChart, dp, friendshipButton },
    data () {
        return {
            who: { id: -1 },
            matches: [ ]
        }
    },
    computed: {
        byline () {
            var byline = [ ]

            const genderSuffix = {
                'female': 'in',
                'male': '',
                'na': '/in'
            }[this.who.sex]

            if (this.who.yob) {
                byline.push(this.who.yob.toString())
            }

            if (this.who.handedness == 'left') {
                byline.push('Linkshänder' + genderSuffix)
            } else if (this.who.handedness == 'right') {
                byline.push('Rechtshänder' + genderSuffix)
            }

            if (this.who.city) {
                byline.push(this.who.city.postal_code + ' ' + this.who.city.name)
            }

            return byline.join(', ')
        }
    },
    methods: {
        fetchData () {
            const that = this
            const requests = []

            const id = this.route.params.id == 'me' ? 
                this.user.id : 
                this.route.params.id

            return this.$api.get('users/' + id)
            .then(response => {
                that.who = response.data.profile

                that.matches = _.filter(response.data.matches, m => {
                    return m.status == 'completed'
                })
            })
        },
        logout () {
            window.store.commit('logout')
            window.router.push('/login')
        }
    }
}
</script>



// WEBPACK FOOTER //
// profile.vue?3b421c48